import React from 'react';
import getBannerUI from 'new/elements/Banner/getBannerUI';

import styles from './Banner.module.scss';

type Props = {
  message: string;
  variant?: 'default' | 'success' | 'warning' | 'error';
};

export function Banner(props: Props) {
  const { variant = 'default', message = '' } = props;

  const { Icon, containerStyle, textStyle } = getBannerUI(variant);

  return (
    <div className={styles.container} style={containerStyle}>
      <div className={styles.icon}>
        <Icon />
      </div>
      <div className={styles.message}>
        <span style={textStyle}>{message}</span>
      </div>
    </div>
  );
}
